import React from 'react';
import { useActiveModules } from '../../hooks/useActiveModules';

const FilterControls = ({
  studentSearch,
  setStudentSearch,
  completedModuleFilters,
  setCompletedModuleFilters,
  showDropdown,
  setShowDropdown,
  dropdownRef,
  setSelectedStudent
}) => {

  const { activeModules, activeModulesIds, activeModulesLoading, activeModulesError } = useActiveModules();

  return (
    <div className="filter-container">
      <input
        type="text"
        placeholder="Search student by name"
        value={studentSearch}
        onChange={(e) => { setStudentSearch(e.target.value); setSelectedStudent(null); }}
        className="student-search-box"
      />

      <div className="filter-by-module-wrapper">
        <div className="custom-multiselect" ref={dropdownRef}>
          <div
            className="multiselect-display"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            {completedModuleFilters.length > 0
              ? `Completed modules: ${completedModuleFilters.join(', ')}`
              : 'Filter by completed modules'}
            <span className="arrow">{showDropdown ? '▲' : '▼'}</span>
          </div>

          {showDropdown && (
            <div className="multiselect-options">
              {activeModules.map((module) => (
                <label key={`filter-module-${module.module_id}`} className="multiselect-option">
                  <input
                    type="checkbox"
                    checked={completedModuleFilters.includes(module.module_id)}
                    onChange={() => {
                      setSelectedStudent(null);

                      if (completedModuleFilters.includes(module.module_id)) {
                        setCompletedModuleFilters(
                          completedModuleFilters.filter((m) => m !== module.module_id)
                        );
                      } else {
                        setCompletedModuleFilters([...completedModuleFilters, module.module_id]);
                      }
                    }}
                  />
                  {module.module_id}
                </label>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilterControls;
